<div class="widget stats-widget" ngClass.xs="double-height xs">
  <div class="card-container front">
    <mat-card
      class="front"
      fxLayout="row"
      fxLayoutWrap
      fxLayoutAlign="space-between stretch"
    >
      <mat-card-content>
        <ix-drag-handle [showReorderHandle]="showReorderHandle">
          <ng-content [select]="[cdkDragHandle]"></ng-content>

          <mat-toolbar-row>
            <!-- Mobile Only: Exit widget -->
            <button
              *ngIf="screenType === ScreenType.Mobile"
              class="mat-card-title-text"
              mat-icon-button
              color="default"
              ixTest="help-back"
              (click)="goBack()"
            >
              <ix-icon name="chevron_left" class="back-arrow"></ix-icon>
            </button>

            <h3 class="mat-card-title-text">
              <ix-drag-handle [showReorderHandle]="showReorderHandle">
                <div class="card-title-text">
                  <span *ngIf="showReorderHandle" class="grip"></span>
                  <span>{{ 'TrueNAS Help' | translate }}</span>
                </div>
              </ix-drag-handle>
            </h3>
          </mat-toolbar-row>
        </ix-drag-handle>

        <div class="content-wrapper container">
          <div class="line-item">
            <div fxFlex="10%">
              <ix-icon class="bullet-icon" name="assignment"></ix-icon>
            </div>
            <div
              fxFlex="90%"
              class="medium-font"
              [innerHtml]="helptext.docs | translate"
            ></div>
          </div>
          <div class="line-item">
            <div fxFlex="10%">
              <ix-icon class="bullet-icon" name="group"></ix-icon>
            </div>
            <div
              fxFlex="90%"
              class="medium-font"
              [innerHtml]="helptext.forums | translate"
            ></div>
          </div>
          <div class="line-item">
            <div fxFlex="10%">
              <ix-icon class="bullet-icon" name="mail"></ix-icon>
            </div>
            <div
              fxFlex="90%"
              class="medium-font"
              [innerHtml]="helptext.newsLetter | translate"
            ></div>
          </div>
          <ng-container *ngIf="systemType === ProductType.Scale">
            <div
              *appLet="systemType | mapValue: productTypeLabels as product"
              id="open-source"
              [innerHtml]="helptext.opensource | translate: { product }"
            ></div>
          </ng-container>
        </div>
        <div id="footer">
          <div class="copyright-txt">
            <ix-copyright-line></ix-copyright-line>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
